import { render, staticRenderFns } from "./ZoneManagementOld.vue?vue&type=template&id=4be80102"
import script from "./ZoneManagementOld.vue?vue&type=script&lang=js"
export * from "./ZoneManagementOld.vue?vue&type=script&lang=js"
import style0 from "./ZoneManagementOld.vue?vue&type=style&index=0&id=4be80102&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports